export default function SearchFilters({ filters, onFilterChange }) {
  const materialTypes = [
    "Textual Records",
    "Photographs and other Graphic Materials",
    "Maps and Charts",
    "Motion Pictures",
    "Sound Recordings",
    "Data Files",
  ];

  const recordTypes = [
    { value: "", label: "All Types" },
    { value: "item", label: "Items" },
    { value: "fileUnit", label: "File Units" },
    { value: "series", label: "Series" },
    { value: "recordGroup", label: "Record Groups" },
    { value: "collection", label: "Collections" },
  ];

  return (
    <div className="flex flex-col gap-4" data-testid="search-filters">
      {/* Online Content Toggle */}
      <div className="flex items-center gap-3">
        <label className="font-mono text-xs uppercase tracking-widest text-[#718096]">
          Available Online
        </label>
        <button
          className={`filter-chip ${filters.available_online === true ? "active" : ""}`}
          onClick={() =>
            onFilterChange({
              ...filters,
              available_online: filters.available_online === true ? null : true,
            })
          }
          data-testid="filter-online-only"
        >
          {filters.available_online === true ? "On" : "Off"}
        </button>
      </div>

      {/* Material Types */}
      <div>
        <label className="font-mono text-xs uppercase tracking-widest text-[#718096] block mb-2">
          Material Type
        </label>
        <div className="flex flex-wrap gap-2">
          <button
            className={`filter-chip ${!filters.type_of_materials ? "active" : ""}`}
            onClick={() => onFilterChange({ ...filters, type_of_materials: "" })}
            data-testid="filter-material-all"
          >
            All
          </button>
          {materialTypes.map((type) => (
            <button
              key={type}
              className={`filter-chip ${filters.type_of_materials === type ? "active" : ""}`}
              onClick={() =>
                onFilterChange({
                  ...filters,
                  type_of_materials: filters.type_of_materials === type ? "" : type,
                })
              }
              data-testid={`filter-material-${type.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {type.split(" ")[0]}
            </button>
          ))}
        </div>
      </div>

      {/* Record Types */}
      <div>
        <label className="font-mono text-xs uppercase tracking-widest text-[#718096] block mb-2">
          Record Level
        </label>
        <div className="flex flex-wrap gap-2">
          {recordTypes.map((type) => (
            <button
              key={type.value}
              className={`filter-chip ${filters.result_types === type.value ? "active" : ""}`}
              onClick={() => onFilterChange({ ...filters, result_types: type.value })}
              data-testid={`filter-record-type-${type.value || "all"}`}
            >
              {type.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
